import { QuestionSupportingDocUploadField } from 'components/Questionnaires/fields';
import { requiredValidator } from 'components/Questionnaires/validators';

export function uploadSupportingDocField({ id, docType, visible, hasFootnote = false, isRequired = true }) {
  const label = `questionnaire.supportingDocUpload.${ docType }.label`;
  const placeholder = `questionnaire.supportingDocUpload.${ docType }.placeholder`;
  const footnote = hasFootnote ? `questionnaire.supportingDocUpload.${ docType }.footnote` : undefined;
  const validation = isRequired
    ? { conditions: [{ condition: requiredValidator, message: 'questionnaire.supportingDocUpload.errorMessage' }] }
    : undefined;
  return {
    id,
    component: QuestionSupportingDocUploadField,
    componentProps: {
      docType
    },
    info: {
      footnote
    },
    label,
    placeholder,
    visible,
    validation
  };
}

export default uploadSupportingDocField;
